export const LOCAL_STORAGE_CONSTANTS = {
  // Persists the user's currently selected application so the choice survives a
  // page refresh / deep-link. Re-validated against the user's app list on load.
  SELECTED_APPLICATION_ID: 'bhub.selectedApplicationId'
}
